const SCRIPT_URL = 'https://widget.modatech.ru/widget.js'
const SCRIPT_ID = 'mcbuy-modatech-widget'
let scriptLoading = null
let initialization = null
let widgetReady = null
let runtimeConfig = null

export function getModatechSessionKey() {
    try {
        const key = window.localStorage.getItem('_garderoboSessionKey')
        return typeof key === 'string' && key.length > 0 && key.length <= 512
            && key !== 'null' && key !== 'undefined' && !/[\x00-\x20\x7f]/.test(key) ? key : null
    } catch (error) {
        return null
    }
}

function loadWidget() {
    if (window._garderoboWidget) { return Promise.resolve(window._garderoboWidget) }
    if (scriptLoading) { return scriptLoading }
    scriptLoading = new Promise((resolve, reject) => {
        const existing = document.getElementById(SCRIPT_ID)
            || document.querySelector('script[src="' + SCRIPT_URL + '"]')
        const script = existing || document.createElement('script')
        const timer = window.setTimeout(() => finish(new Error('Modatech script timeout')), 5000)
        function finish(error) {
            window.clearTimeout(timer)
            script.removeEventListener('load', loaded)
            script.removeEventListener('error', failed)
            if (error) {
                if (!existing) { script.remove() }
                reject(error)
            } else if (window._garderoboWidget) {
                resolve(window._garderoboWidget)
            } else {
                reject(new Error('Modatech widget unavailable'))
            }
        }
        function loaded() { finish() }
        function failed() { finish(new Error('Modatech script unavailable')) }
        script.addEventListener('load', loaded, {once: true})
        script.addEventListener('error', failed, {once: true})
        if (!existing) {
            script.id = SCRIPT_ID
            script.src = SCRIPT_URL
            script.async = true
            document.head.appendChild(script)
        }
    })
    return scriptLoading
}

function sessionFromStorage() {
    return new Promise(resolve => {
        let attempts = 0
        function check() {
            const key = getModatechSessionKey()
            if (key || ++attempts >= 100) { resolve(key); return }
            window.setTimeout(check, 50)
        }
        check()
    })
}

// Preserve the analytics API (session key/null); expose the same initialized SDK to views.
export function getModatechWidget(axios) {
    if (widgetReady) { return widgetReady }
    widgetReady = axios.get('api/modatech/', {timeout: 5000}).then(response => {
        const config = response.data && response.data.status === 'success' && response.data.data
        if (!config || typeof config.apiKey !== 'string' || !config.apiKey) {
            throw new Error('Modatech configuration unavailable')
        }
        return withTimeout(loadWidget(), 7000).then(widget => {
            widget.init(config.apiKey, {lang_code: 'ru', user_id: config.userId || '', spa: true})
            runtimeConfig = config
            return widget
        })
    })
    return widgetReady
}

export function getModatechUserId() {
    return runtimeConfig ? String(runtimeConfig.userId || '') : null
}

function withTimeout(promise, milliseconds) {
    return new Promise((resolve, reject) => {
        const timer = window.setTimeout(() => reject(new Error('Modatech initialization timeout')), milliseconds)
        Promise.resolve(promise).then(value => {
            window.clearTimeout(timer)
            resolve(value)
        }, error => {
            window.clearTimeout(timer)
            reject(error)
        })
    })
}

export function initializeModatechSession(axios) {
    if (!initialization) {
        initialization = getModatechWidget(axios).then(sessionFromStorage).catch(() => null)
    }
    return initialization
}

export function waitForModatechSession() {
    if (getModatechSessionKey() || !initialization) { return Promise.resolve() }
    // Checkout waits at most 1.5 seconds for an already-started initialization.
    // The application itself mounts immediately and keeps working if Modatech is offline.
    return new Promise(resolve => {
        const timer = window.setTimeout(resolve, 1500)
        initialization.then(() => { window.clearTimeout(timer); resolve() })
    })
}
